import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import HomePage from "../pages/HomePage";
import EnrollPage from "../pages/EnrollPage";
import ThankYouPage from "../pages/ThankYouPage";
import NotFound from "../pages/404";
import SignIn from "../pages/SignIn";
import Register from "../pages/Register";
import ContactPage from "../pages/Contact";
import YoungFounders from "../pages/YoungFounders";
import RaiseABuilder from "../pages/RaiseABuilder";
import { ForgotPasswordPage, ResetPasswordPage } from "../pages/PasswordPages";

export const HomeRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/home" element={<Navigate to="/" replace />} />

      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="/young-founders" element={<YoungFounders />} />
      <Route path="/raise-a-builder" element={<RaiseABuilder />} />
      <Route path="/enroll" element={<EnrollPage />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
    </Routes>
  );
};

export default HomeRoutes;
